import {css} from 'styled-components';

export const getToastifyStyles = () => css`
  :root {
    --toastify-color-light: #fff;
    --toastify-color-dark: #161643;
    --toastify-color-info: #3498db;
    --toastify-color-success: #07bc0c;
    --toastify-color-warning: #f1c40f;
    --toastify-color-error: #e74c3c;
    --toastify-color-transparent: rgba(255, 255, 255, 0.7);
    --toastify-icon-color-info: var(--toastify-color-info);
    --toastify-icon-color-success: var(--toastify-color-success);
    --toastify-icon-color-warning: var(--toastify-color-warning);
    --toastify-icon-color-error: var(--toastify-color-error);
    --toastify-toast-width: 320px;
    --toastify-toast-offset: 16px;
    --toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));
    --toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));
    --toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));
    --toastify-toast-bottom: max(
      var(--toastify-toast-offset),
      env(safe-area-inset-bottom)
    );
    --toastify-toast-background: #fff;
    --toastify-toast-min-height: 64px;
    --toastify-toast-max-height: 800px;
    --toastify-toast-bd-radius: 6px;
    --toastify-font-family: sans-serif;
    --toastify-z-index: 9999;
    --toastify-text-color-light: #757575;
    --toastify-text-color-dark: #fff;
    --toastify-text-color-info: #fff;
    --toastify-text-color-success: #fff;
    --toastify-text-color-warning: #fff;
    --toastify-text-color-error: #fff;
    --toastify-spinner-color: #616161;
    --toastify-spinner-color-empty-area: #e0e0e0;
  }

  .Toastify__toast-container {
    z-index: var(--toastify-z-index);
    -webkit-transform: translate3d(0, 0, var(--toastify-z-index));
    position: fixed;
    padding: 4px;
    width: var(--toastify-toast-width);
    box-sizing: border-box;
    color: #fff;
  }
  .Toastify__toast-container--top-left {
    top: var(--toastify-toast-top);
    left: var(--toastify-toast-left);
  }
  .Toastify__toast-container--top-center {
    top: var(--toastify-toast-top);
    left: 50%;
    transform: translateX(-50%);
  }
  .Toastify__toast-container--top-right {
    top: var(--toastify-toast-top);
    right: var(--toastify-toast-right);
  }
  .Toastify__toast-container--bottom-left {
    bottom: var(--toastify-toast-bottom);
    left: var(--toastify-toast-left);
  }
  .Toastify__toast-container--bottom-center {
    bottom: var(--toastify-toast-bottom);
    left: 50%;
    transform: translateX(-50%);
  }
  .Toastify__toast-container--bottom-right {
    bottom: var(--toastify-toast-bottom);
    right: var(--toastify-toast-right);
  }

  @media only screen and (max-width: 480px) {
    .Toastify__toast-container {
      width: 100vw;
      padding: 0;
      left: env(safe-area-inset-left);
      margin: 0;
    }
    .Toastify__toast-container--top-left,
    .Toastify__toast-container--top-center,
    .Toastify__toast-container--top-right {
      top: env(safe-area-inset-top);
      transform: translateX(0);
    }
    .Toastify__toast-container--bottom-left,
    .Toastify__toast-container--bottom-center,
    .Toastify__toast-container--bottom-right {
      bottom: env(safe-area-inset-bottom);
      transform: translateX(0);
    }
    .Toastify__toast-container--rtl {
      right: env(safe-area-inset-right);
      left: initial;
    }
  }
  .Toastify__toast {
    --y: 0;
    position: relative;
    -ms-touch-action: none;
    touch-action: none;
    min-height: var(--toastify-toast-min-height);
    box-sizing: border-box;
    margin-bottom: 1rem;
    padding: 8px;
    border-radius: var(--toastify-toast-bd-radius);
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    max-height: var(--toastify-toast-max-height);
    font-family: var(--toastify-font-family);
    cursor: default;
    direction: ltr;
    /* webkit only issue #791 */
    z-index: 0;
    overflow: hidden;
  }
  .Toastify__toast--stacked {
    position: absolute;
    width: 100%;
    transform: translate3d(0, var(--y), 0) scale(var(--s));
    transition: transform 0.3s;
  }
  .Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,
  .Toastify__toast--stacked[data-collapsed] .Toastify__close-button {
    transition: opacity 0.1s;
  }
  .Toastify__toast--stacked[data-collapsed='false'] {
    overflow: visible;
  }
  .Toastify__toast--stacked[data-collapsed='true']:not(:last-child) > * {
    opacity: 0;
  }
  .Toastify__toast--stacked:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    height: calc(var(--g) * 1px);
    bottom: 100%;
  }
  .Toastify__toast--stacked[data-pos='top'] {
    top: 0;
  }
  .Toastify__toast--stacked[data-pos='bot'] {
    bottom: 0;
  }
  .Toastify__toast--stacked[data-pos='bot'].Toastify__toast--stacked:before {
    transform-origin: top;
  }
  .Toastify__toast--stacked[data-pos='top'].Toastify__toast--stacked:before {
    transform-origin: bottom;
  }
  .Toastify__toast--stacked:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    transform: scaleY(3);
    z-index: -1;
  }
  .Toastify__toast--rtl {
    direction: rtl;
  }
  .Toastify__toast--close-on-click {
    cursor: pointer;
  }
  .Toastify__toast-body {
    margin: auto 0;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 6px;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
  }
  .Toastify__toast-body > div:last-child {
    word-break: break-word;
    -ms-flex: 1;
    flex: 1;
  }
  .Toastify__toast-icon {
    -webkit-margin-end: 10px;
    margin-inline-end: 10px;
    width: 20px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    display: -ms-flexbox;
    display: flex;
  }

  .Toastify--animate {
    animation-fill-mode: both;
    animation-duration: 0.5s;
  }

  .Toastify--animate-icon {
    animation-fill-mode: both;
    animation-duration: 0.3s;
  }

  @media only screen and (max-width: 480px) {
    .Toastify__toast {
      margin-bottom: 0;
      border-radius: 0;
    }
  }

  .Toastify__toast-theme--light {
    background: var(--toastify-color-light);
    color: var(--toastify-text-color-light);
  }
  .Toastify__toast-theme--colored.Toastify__toast--default {
    background: var(--toastify-color-light);
    color: var(--toastify-text-color-light);
  }
  .Toastify__toast-theme--colored.Toastify__toast--info {
    color: var(--toastify-text-color-info);
    background: var(--toastify-color-info);
  }
  .Toastify__toast-theme--colored.Toastify__toast--success {
    color: var(--toastify-text-color-success);
    background: var(--toastify-color-success);
  }
  .Toastify__toast-theme--colored.Toastify__toast--warning {
    color: var(--toastify-text-color-warning);
    background: var(--toastify-color-warning);
  }
  .Toastify__toast-theme--colored.Toastify__toast--error {
    color: var(--toastify-text-color-error);
    background: var(--toastify-color-error);
  }

  .Toastify__close-button {
    color: #fff;
    background: transparent;
    outline: none;
    border: none;
    padding: 0;
    cursor: pointer;
    opacity: 0.7;
    transition: 0.3s ease;
    -ms-flex-item-align: start;
    align-self: flex-start;
    z-index: 1;
  }
  .Toastify__close-button--light {
    color: #000;
    opacity: 0.3;
  }
  .Toastify__close-button > svg {
    fill: currentColor;
    height: 16px;
    width: 14px;
  }
  .Toastify__close-button:hover,
  .Toastify__close-button:focus {
    opacity: 1;
  }

  @keyframes Toastify__bounceInRight {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    from {
      opacity: 0;
      transform: translate3d(3000px, 0, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(-25px, 0, 0);
    }
    75% {
      transform: translate3d(10px, 0, 0);
    }
    90% {
      transform: translate3d(-5px, 0, 0);
    }
    to {
      transform: none;
    }
  }
  @keyframes Toastify__bounceOutRight {
    20% {
      opacity: 1;
      transform: translate3d(-20px, var(--y), 0);
    }
    to {
      opacity: 0;
      transform: translate3d(2000px, var(--y), 0);
    }
  }

  @keyframes Toastify__bounceInUp {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    from {
      opacity: 0;
      transform: translate3d(0, 3000px, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(0, -20px, 0);
    }
    75% {
      transform: translate3d(0, 10px, 0);
    }
    90% {
      transform: translate3d(0, -5px, 0);
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes Toastify__bounceOutUp {
    20% {
      transform: translate3d(0, calc(var(--y) - 10px), 0);
    }
    40%,
    45% {
      opacity: 1;
      transform: translate3d(0, calc(var(--y) + 20px), 0);
    }
    to {
      opacity: 0;
      transform: translate3d(0, -2000px, 0);
    }
  }
  @keyframes Toastify__bounceInDown {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
      opacity: 0;
      transform: translate3d(0, -3000px, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(0, 25px, 0);
    }
    75% {
      transform: translate3d(0, -10px, 0);
    }
    90% {
      transform: translate3d(0, 5px, 0);
    }
    to {
      transform: none;
    }
  }
  @keyframes Toastify__bounceOutDown {
    20% {
      transform: translate3d(0, calc(var(--y) - 10px), 0);
    }
    40%,
    45% {
      opacity: 1;
      transform: translate3d(0, calc(var(--y) + 20px), 0);
    }
    to {
      opacity: 0;
      transform: translate3d(0, 2000px, 0);
    }
  }
  .Toastify__bounce-enter--top-right,
  .Toastify__bounce-enter--bottom-right {
    animation-name: Toastify__bounceInRight;
  }
  .Toastify__bounce-enter--top-center {
    animation-name: Toastify__bounceInDown;
  }
  .Toastify__bounce-enter--bottom-center {
    animation-name: Toastify__bounceInUp;
  }

  .Toastify__bounce-exit--top-left,
  .Toastify__bounce-exit--bottom-left {
    animation-name: Toastify__bounceOutLeft;
  }
  .Toastify__bounce-exit--top-right,
  .Toastify__bounce-exit--bottom-right {
    animation-name: Toastify__bounceOutRight;
  }
  .Toastify__bounce-exit--top-center {
    animation-name: Toastify__bounceOutUp;
  }
  .Toastify__bounce-exit--bottom-center {
    animation-name: Toastify__bounceOutDown;
  }

  @keyframes Toastify__slideInRight {
    from {
      transform: translate3d(110%, 0, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, var(--y), 0);
    }
  }
  @keyframes Toastify__slideInUp {
    from {
      transform: translate3d(0, 110%, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, var(--y), 0);
    }
  }
  @keyframes Toastify__slideInDown {
    from {
      transform: translate3d(0, -110%, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, var(--y), 0);
    }
  }
  @keyframes Toastify__slideOutRight {
    from {
      transform: translate3d(0, var(--y), 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(110%, var(--y), 0);
    }
  }
  @keyframes Toastify__slideOutDown {
    from {
      transform: translate3d(0, var(--y), 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(0, 500px, 0);
    }
  }
  @keyframes Toastify__slideOutUp {
    from {
      transform: translate3d(0, var(--y), 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(0, -500px, 0);
    }
  }

  .Toastify__slide-enter--top-right,
  .Toastify__slide-enter--bottom-right {
    animation-name: Toastify__slideInRight;
  }
  .Toastify__slide-enter--top-center {
    animation-name: Toastify__slideInDown;
  }
  .Toastify__slide-enter--bottom-center {
    animation-name: Toastify__slideInUp;
  }

  .Toastify__slide-exit--top-right,
  .Toastify__slide-exit--bottom-right {
    animation-name: Toastify__slideOutRight;
    animation-timing-function: ease-in;
    animation-duration: 0.3s;
  }
  .Toastify__slide-exit--top-center {
    animation-name: Toastify__slideOutUp;
    animation-timing-function: ease-in;
    animation-duration: 0.3s;
  }
  .Toastify__slide-exit--bottom-center {
    animation-name: Toastify__slideOutDown;
    animation-timing-function: ease-in;
    animation-duration: 0.3s;
  }
`;
